// src/pages/AuthActionRouter.js
import React from "react";
import { useSearchParams } from "react-router-dom";
import VerifyEmail from "./VerifyEmail";
import ResetPassword from "./ResetPassword"; // you'll create this

const AuthActionRouter = () => {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode");

  if (mode === "verifyEmail") {
    return <VerifyEmail />;
  } else if (mode === "resetPassword") {
    return <ResetPassword />;
  } else {
    return <p>⚠️ Invalid action mode</p>;
  }
};

export default AuthActionRouter;
